import React, { useEffect, useState } from "react";
import {
  Container,
  Table,
  TableHead,
  TableBody,
  TableRow,
  TableCell,
  Button,
  ToggleButton,
  ToggleButtonGroup,
  IconButton,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  MenuItem,
  FormControl,
  InputLabel,
  Typography,
  Paper,
  Box,
  Tooltip,
  Modal,
  Alert,
  Snackbar,
  Card,
  TableContainer,
  CircularProgress,
} from "@mui/material";
import { ChevronLeft, ChevronRight, EditIcon, X } from "lucide-react";
import {
  LocalizationProvider,
  DatePicker,
  DateCalendar,
} from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import CalendarMonthIcon from "@mui/icons-material/CalendarMonth";
import dayjs from "dayjs";
import { useTheme } from "../../style/theme";
import { CiExport, CiImport } from "react-icons/ci";
import { IoIosArrowBack, IoIosArrowForward, IoIosMore } from "react-icons/io";
import { TfiDownload } from "react-icons/tfi";
import { BsPrinter } from "react-icons/bs";
import { IoCalendarOutline } from "react-icons/io5";
import { useForm, Controller } from "react-hook-form";
import Select from "react-select";
import axios from "axios";
import isSameOrAfter from "dayjs/plugin/isSameOrAfter";
import isSameOrBefore from "dayjs/plugin/isSameOrBefore";

dayjs.extend(isSameOrAfter);
dayjs.extend(isSameOrBefore);

const EditShiftModal = ({ open, handleClose, mode }) => {
  const { mode: themeMode } = useTheme();
  const [shiftOptions, setshiftOptions] = useState([]);
  const currentOrg = JSON.parse(localStorage.getItem("org"));
  const currentEmp = JSON.parse(localStorage.getItem("emp"));
  const todayStr = new Date().toISOString().split("T")[0];
  const [loading, setLoading] = useState(false);
  const { handleSubmit, control, reset, formState: { errors } } = useForm();

  // Fetch shift options
  const fetchShifts = async () => {
    try {
      const response = await axios.get(
        `/hr/adminShift?orgId=${currentOrg?._id}`
      );
      const shifts = response?.data?.data;

      const formatted = shifts?.map((emp) => ({
        value: emp?._id,
        label: `${emp?.shiftName} ${emp?.workedTime?.from} - ${emp?.workedTime?.to}`,
      }));

      setshiftOptions(formatted);
    } catch (e) {
      console.log(e);
    }
  };

  useEffect(() => {
    fetchShifts();
  }, []);

  // Form submit
  const onSubmit = async (data) => {
    const payload = {
      userId: currentEmp?._id,
      adminId: currentOrg?._id,
      shiftName: data.shiftName?.value,
      fromDate: data.fromDate,
      toDate: data.toDate,
      reason: data.reason,
    };

    try {
      setLoading(true);
      await axios.post("/hr/employeeShift", payload);
      handleClose();
    } catch (error) {
      console.error("Submit error:", error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      fullWidth
      maxWidth="sm"
      PaperProps={{
        sx: {
          bgcolor: themeMode === "dark" ? "#141414" : "background.paper",
          borderRadius: 2,
        },
      }}
    >
      <DialogTitle
        sx={{
          p: 0,
          bgcolor: themeMode === "dark" ? "#141414" : "background.paper",
        }}
      >
        <div className="p-4 flex justify-between items-center">
          <Typography variant="h6" fontWeight="bold">
            Assign Shift
          </Typography>
          <button
            className="p-1 rounded-md border-none outline-none"
            onClick={handleClose}
            type="button"
            style={{ backgroundColor: themeMode === "light" ? "#dcdcdc" : "" }}
          >
            <X size={20} />
          </button>
        </div>
      </DialogTitle>

      <form onSubmit={handleSubmit(onSubmit)} className="flex flex-col">
        <DialogContent
          sx={{
            bgcolor: themeMode === "dark" ? "#141414" : "background.paper",
          }}
        >
          <div clasName="p-4">
            {/* Shift Name */}
            <FormControl fullWidth sx={{ mt: 1 }}>
              <label className="text-[14px]">Shift Name</label>
              <Controller
                name="shiftName"
                control={control}
                rules={{ required: "Shift is required" }}
                render={({ field }) => (
                  <>
                    <Select
                      {...field}
                      options={shiftOptions}
                      placeholder="Select shift"
                      isClearable
                      styles={{
                        control: (provided) => ({
                          ...provided,
                          backgroundColor:
                            themeMode === "light" ? "#fff" : "#141414",
                        }),
                        menu: (provided) => ({
                          ...provided,
                          backgroundColor:
                            themeMode === "light" ? "#fff" : "#141414",
                        }),
                        option: (provided, state) => ({
                          ...provided,
                          backgroundColor: state.isFocused
                            ? "#e0e0e0"
                            : "#f0f0f0",
                          color: "#000",
                        }),
                      }}
                    />
                    {errors?.shiftName && (
                      <span className="text-red-500 text-xs mt-1">
                        {errors.shiftName.message}
                      </span>
                    )}
                  </>
                )}
              />
            </FormControl>

            {/* From Date */}
            <Box className="mt-2">
              <label className="text-[14px] mt-2">From</label>
              {/* <Controller
                name="fromDate"
                control={control}
                rules={{ required: true }}
                defaultValue={new Date().toISOString().split("T")[0]}
                render={({ field }) => (
                  <TextField
                    {...field}
                    type="date"
                    fullWidth
                    size="small"
                    InputLabelProps={{ shrink: true }}
                  />
                )}
              /> */}

              <Controller
                name="fromDate"
                control={control}
                rules={{ required: true }}
                defaultValue={todayStr}
                render={({ field }) => (
                  <TextField
                    {...field}
                    type="date"
                    fullWidth
                    size="small"
                    InputLabelProps={{ shrink: true }}
                    inputProps={{ min: todayStr }}
                  />
                )}
              />
            </Box>

            {/* To Date */}
            <label className="text-[14px] mt-2">To</label>
            {/* <Controller
              name="toDate"
              control={control}
              rules={{ required: true }}
              defaultValue={new Date().toISOString().split("T")[0]}
              render={({ field }) => (
                <TextField
                  {...field}
                  type="date"
                  fullWidth
                  size="small"
                  InputLabelProps={{ shrink: true }}
                />
              )}
            /> */}
            <Controller
              name="toDate"
              control={control}
              rules={{ required: "To date is required" }}
              defaultValue={todayStr}
              render={({ field }) => (
                <TextField
                  {...field}
                  type="date"
                  fullWidth
                  size="small"
                  InputLabelProps={{ shrink: true }}
                  inputProps={{ min: todayStr }}
                  error={!!errors.toDate}
                  helperText={errors.toDate?.message}
                />
              )}
            />


            {/* Reason */}
            <label className="text-[14px] mt-2">Reason</label>
            <Controller
              name="reason"
              control={control}
              rules={{ required: "Reason is required" }}
              render={({ field }) => (
                <TextField
                  {...field}
                  fullWidth
                  multiline
                  rows={3}
                  size="small"
                  error={!!errors.reason}
                  helperText={errors.reason?.message}
                />
              )}
            />
          </div>
        </DialogContent>

        <div
          className={`p-4 flex justify-between items-center ${themeMode === "dark" ? "bg-[#141414]" : "bg-[#fff]"
            }`}
        >
          <Button
            type="submit"
            variant="contained"
            disabled={loading}
            sx={{ backgroundColor: "#0080FF", minWidth: 130 }}
          >
            {loading ? (
              <CircularProgress size={20} sx={{ color: "#fff" }} />
            ) : (
              "Assign Shift"
            )}
          </Button>
          <Button variant="outlined" onClick={handleClose}>
            Cancel
          </Button>
        </div>
      </form>
    </Dialog>
  );
};

const MonthTab = ({ selectedShift, selectedDate }) => {
  const [currentDate, setCurrentDate] = useState(dayjs());

  const { mode: themeMode } = useTheme();
  const startOfMonth = selectedDate.startOf("month");
  const endOfMonth = selectedDate.endOf("month");
  const daysInMonth = endOfMonth.date();

  const prevMonth = () => setCurrentDate(currentDate.subtract(1, "month"));
  const nextMonth = () => setCurrentDate(currentDate.add(1, "month"));
  console.log(selectedShift, "selectedShiftselectedShift");
  const weekdays = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];

  // ✅ Pehle din ka weekday nikalna
  const firstDayIndex = startOfMonth.day();
  const lastDayIndex = endOfMonth.day();

  // ✅ Shifts ko dynamically generate karna
  //  const shifts = Array.from({ length: daysInMonth }, (_, index) => ({
  //   type: selectedShift?.shiftName,
  //   time: selectedShift?.workedTime,
  // }));

  const shifts = Array.from({ length: daysInMonth }, (_, index) => {
    const day = dayjs(startOfMonth).add(index, "day"); // Current day in loop

    // Find the shift for current day from the array of shifts
    const matchingShift = selectedShift?.find((shift) => {
      const from = dayjs(shift.fromDate);
      const to = dayjs(shift.toDate);
      return day.isSameOrAfter(from, "day") && day.isSameOrBefore(to, "day");
    });

    if (matchingShift) {
      return {
        type: matchingShift?.shiftName || "General",
        time: matchingShift?.workedTime,
      };
    } else {
      return {
        type: "General",
        time: "09:00 AM - 06:00 PM",
      };
    }
  });

  return (
    <div style={{ backgroundColor: "background.paper" }} className="rounded-lg">
      <div
        className={`${themeMode === "light" ? "bg-[#fff]" : ""} px-2 sm:px-4`}
      >
        {/* Weekday Headers */}
        <div className="overflow-x-auto">
          <div className="grid grid-cols-7 text-center font-semibold rounded-md min-w-[700px] sm:min-w-full">
            {weekdays.map((day) => (
              <div
                style={{
                  border:
                    themeMode === "dark" ? "1px solid #353535" : "1px solid",
                }}
                key={day}
                className="text-sm p-2 sm:text-base text-gray-600"
              >
                {day}
              </div>
            ))}
          </div>

          <div className="grid grid-cols-7 min-w-[700px] sm:min-w-full">
            {/* Empty slots for days before the first day */}
            {Array.from({ length: firstDayIndex }).map((_, index) => (
              <div
                key={`empty-${index}`}
                style={{
                  border:
                    themeMode === "dark" ? "1px solid #353535" : "1px solid",
                }}
                className="h-24 sm:h-20 md:h-24 p-2"
              ></div>
            ))}
            {Array.from({ length: lastDayIndex }).map((_, index) => (
              <div
                key={`empty-${index}`}
                style={{
                  border:
                    themeMode === "dark" ? "1px solid #353535" : "1px solid",
                }}
                className="h-24 sm:h-20 md:h-24 p-2"
              ></div>
            ))}

            {/* Days of the month */}
            {[...Array(daysInMonth)].map((_, dayIndex) => {
              const day = dayIndex + 1;
              const shift = shifts[dayIndex];

              return (
                <div
                  key={day}
                  style={{
                    border:
                      themeMode === "dark" ? "1px solid #353535" : "1px solid",
                  }}
                  className="relative h-24 sm:h-20 md:h-24 p-2 flex flex-col"
                >
                  <div className="absolute top-1 left-1 text-gray-500 text-xs sm:text-sm">
                    {day}
                  </div>

                  {shift && (
                    <div
                      style={{
                        borderLeft: "3px solid #999898",
                        backgroundColor:
                          themeMode === "dark" ? "#1f1f1f" : "#f6f6f6",
                      }}
                      className="rounded-lg relative  flex-col mt-[30px] w-full px-2 group inline-block"
                    >
                      <span className="text-[8px] sm:text-[10px] md:text-sm py-1">
                        {shift?.type}
                      </span>
                      <span className="text-[8px] sm:text-[10px] md:text-xs text-gray-500">
                        {shift?.time}
                      </span>
                    </div>
                  )}
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </div>
  );
};

const WeekTab = ({ selectedShift, selectedDate }) => {
  const [mode, setMode] = useState("edit");
  const [open, setOpen] = useState(false);
  const { mode: themeMode } = useTheme();
  const handleOpen = (selectedMode) => {
    setMode(selectedMode);
    setOpen(true);
  };

  const today = dayjs(selectedDate); // or use a fixed week start for testing
  const startOfWeek = today.startOf("week"); // Sunday

  // Dynamically generate 7 days of the week
  // const shifts = Array.from({ length: 7 }, (_, index) => {
  //   const date = dayjs(startOfWeek).add(index, "day");
  //   const shiftForDate = selectedShift?.find((shift) => {
  //     const from = dayjs(shift.fromDate);
  //     const to = dayjs(shift.toDate);
  //     return date.isSameOrAfter(from, "day") && date.isSameOrBefore(to, "day");
  //   });

  //   return {
  //     day: date.format("ddd"),
  //     date: date.format("D"),
  //     shift: shiftForDate?.shiftName || "General",
  //     time: shiftForDate?.workedTime || "09:00 AM - 06:00 PM",
  //   };
  // });

  const shifts = Array?.from({ length: 7 }, (_, index) => {
    const date = startOfWeek?.add(index, "day");
    const shiftForDate = selectedShift?.find((shift) => {
      const from = dayjs(shift.fromDate);
      const to = dayjs(shift.toDate);
      return date.isSameOrAfter(from, "day") && date.isSameOrBefore(to, "day");
    });

    return {
      day: date.format("ddd"),
      date: date.format("D"),
      shift: shiftForDate?.shiftName || "General",
      time: shiftForDate?.workedTime || "09:00 AM - 06:00 PM",
    };
  });



  return (
    <div>
      <TableContainer sx={{ width: "100%", overflowX: "auto" }}>
        <Table
          sx={{
            border:
              themeMode === "dark" ? "1px solid #353535" : "1px solid #ddd",
            minWidth: 600,
          }}
        >
          <TableHead sx={{ backgroundColor: "background.paper" }}>
            <TableRow>
              <TableCell
                sx={{
                  textAlign: "center",
                  fontWeight: "bold",
                  border:
                    themeMode === "dark"
                      ? "1px solid #353535"
                      : "1px solid #e0e0e0",
                }}
              ></TableCell>
              <TableCell
                sx={{
                  textAlign: "center",
                  // fontWeight: "bold",
                  border:
                    themeMode === "dark"
                      ? "1px solid #353535"
                      : "1px solid #e0e0e0",
                  color: themeMode === "dark" ? "#A5A5A5" : "",
                }}
              >
                08:00 AM
              </TableCell>
              {[
                "09:00 AM",
                "10:00 AM",
                "11:00 AM",
                "12:00 PM",
                "01:00 PM",
                "02:00 PM",
                "03:00 PM",
                "04:00 PM",
                "05:00 PM",
                "06:00 PM",
              ].map((time) => (
                <TableCell
                  key={time}
                  sx={{
                    textAlign: "center",
                    // fontWeight: "bold",
                    border:
                      themeMode === "dark"
                        ? "1px solid #353535"
                        : "1px solid #e0e0e0",
                    whiteSpace: "nowrap", // Prevent text wrap
                    fontSize: { xs: "10px", sm: "12px", md: "14px" },
                    color: themeMode === "dark" ? "#A5A5A5" : "",
                  }}
                >
                  {time}
                </TableCell>
              ))}
            </TableRow>
          </TableHead>
          <TableBody>
            {shifts.map((shift, index) => (
              <TableRow
                key={index}
                sx={{
                  backgroundColor: "background.paper",
                }}
              >
                <TableCell
                  sx={{
                    textAlign: "center",
                    border:
                      themeMode === "dark"
                        ? "1px solid #353535"
                        : "1px solid #e0e0e0",
                    backgroundColor:
                      themeMode === "light" && shift.day === "Sun"
                        ? "#fff7e5"
                        : "",
                    fontSize: { xs: "10px", sm: "12px", md: "14px" },
                    color: themeMode === "dark" ? "#A5A5A5" : "",
                  }}
                >
                  {shift.day} <br />
                  {shift.date}
                </TableCell>
                <TableCell
                  sx={{
                    textAlign: "center",
                    border:
                      themeMode === "dark"
                        ? "1px solid #353535"
                        : "1px solid #e0e0e0",
                    backgroundColor:
                      themeMode === "light" && shift.day === "Sun"
                        ? "#fff7e5"
                        : "",
                  }}
                ></TableCell>
                <TableCell
                  sx={{
                    textAlign: "center",
                    border:
                      themeMode === "dark"
                        ? "1px solid #353535"
                        : "1px solid #e0e0e0",
                    position: "relative",
                    backgroundColor:
                      themeMode === "light" && shift.day === "Sun"
                        ? "#fff7e5"
                        : "",
                  }}
                  colSpan={9}
                >
                  <Typography
                    variant="body2"
                    sx={{
                      backgroundColor: themeMode === "light" ? "#f6f6f6" : "",
                      p: 1,
                      textAlign: "start",
                      borderLeft: "3px solid #999898",
                      fontSize: { xs: "10px", sm: "12px", md: "14px" },
                      position: "relative",
                      "&:hover .edit-icon": { opacity: 1 },
                    }}
                  >
                    {shift.shift} <br />{" "}
                    <span
                      style={{ color: themeMode === "dark" ? "#a5a5a5" : "" }}
                    >
                      {shift.time}
                    </span>
                    {shift.shift !== "" && (
                      <Tooltip title="Edit Shift">
                        <IconButton
                          className="edit-icon"
                          size="small"
                          sx={{
                            position: "absolute",
                            top: 2,
                            left: "-10px",
                            transform: "translateY(-30%)",
                            backgroundColor: "background.paper",
                            opacity: 0,
                            transition: "opacity 0.3s ease-in-out",
                            "&:hover": {
                              backgroundColor: "background.paper",
                            },
                            fontSize: "12px",
                          }}
                          onClick={() => handleOpen("edit")}
                        >
                          <EditIcon size={15} />
                        </IconButton>
                      </Tooltip>
                    )}
                  </Typography>
                </TableCell>
                <TableCell
                  sx={{
                    textAlign: "center",
                    border:
                      themeMode === "dark"
                        ? "1px solid #353535"
                        : "1px solid #e0e0e0",
                    backgroundColor:
                      themeMode === "light" && shift.day === "Sun"
                        ? "#fff7e5"
                        : "",
                  }}
                ></TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>

      <EditShiftModal
        open={open}
        handleClose={() => setOpen(false)}
        mode={mode}
      />
    </div>
  );
};

const Shift = () => {
  const [view, setView] = useState("Weekly");
  const [dateRange, setDateRange] = useState(null);
  const [mode, setMode] = useState("edit");
  const [open, setOpen] = useState(false);
  const [isOpen, setIsOpen] = useState(false);
  const { mode: themeMode } = useTheme();
  const [openCalendar, setOpenCalendar] = useState(false);
  const [selectedDate, setSelectedDate] = useState(dayjs());
  const [shift, setShift] = useState();
  const [loading, setLoading] = useState(true);
  const startOfWeek = selectedDate.startOf("week");
  const endOfWeek = startOfWeek.add(6, "day");
  const formattedStart = startOfWeek.format("DD/MM/YYYY");
  const formattedEnd = endOfWeek.format("DD/MM/YYYY");
  let currentOrg = JSON.parse(localStorage.getItem("org"));
  let currentEmp = JSON.parse(localStorage.getItem("emp"));
  const [selectedShift, setSelectedShift] = useState(null);
  const monthYearLabel = selectedDate?.format("MMMM YYYY"); // e.g., "July 2025"

  useEffect(() => {
    axios
      .get(`/hr/employeeShift?empId=${currentEmp?._id}`)
      .then((res) => {
        const request = res?.data?.data;
        const approvedShifts = request?.filter(
          (req) => req?.status === "approved"
        );

        if (approvedShifts?.length > 0) {
          const mappedShifts = approvedShifts.map((req) => ({
            shiftName: req?.shiftName?.shiftName,
            fromDate: req?.fromDate,
            toDate: req?.toDate,
            workedTime: `${req?.shiftName?.workedTime?.from || "09:00 AM"} - ${req?.shiftName?.workedTime?.to || "6:00 PM"}`,
          }));
          setSelectedShift(mappedShifts);
        } else {
          setSelectedShift([]); // no approved shifts
        }
      })
      .catch((err) => {
        console.error("Failed to fetch shift data", err);
      });
  }, []);

  useEffect(() => {
    if (view === "Monthly") {
      const firstDayOfMonth = dayjs().startOf("month");
      setSelectedDate(firstDayOfMonth);
    } else if (view === "Weekly") {
      const today = dayjs();
      setSelectedDate(today.startOf("week"))
      const startOfWeek = selectedDate.startOf("week");
    }
  }, [view]);


  const handlePrevWeek = () => {
    if (view == 'Weekly') {
      setSelectedDate(selectedDate.subtract(7, "day"));
    } else {
      setSelectedDate((prev) => prev.subtract(1, "month"));
    }
  };

  const handleNextWeek = () => {
    if (view == 'Weekly') {
      setSelectedDate(selectedDate.add(7, "day"));
    } else {
      setSelectedDate((prev) => prev.add(1, "month"));
    }
  };

  const handleOpen = (selectedMode) => {
    setOpen(true);
    setMode(selectedMode);
  };

  return (
    <>
      <Box
        sx={{
          background: "background.paper",
          borderRadius: 2,
          marginBottom: { md: "0px", xs: "60px" },
        }}
      >
        {/* HEADER */}
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: { md: "center", xs: "start" },
            flexDirection: { xs: "column", md: "row" },
            marginBottom: "20px",
          }}
          className="p-2 mx-[20px]"
        >
          <div></div>

          <div className="flex relative md:ms-[170px] items-center gap-2">
            {/* Previous Week Button */}
            <div
              style={{
                backgroundColor: themeMode === "dark" ? "#1E1E1E" : "white",
              }}
              className="flex items-center gap-2 p-2 rounded-md"
            >
              <IoIosArrowBack
                fontSize="small"
                className="cursor-pointer hover:text-gray-600"
                onClick={handlePrevWeek}
                // color="#398aff"
                sx={{ color: mode === "dark" ? "#A5A5A5" : "" }}
              />

              {/* Calendar Icon and Date Range Text */}
              <Box
                className={`relative flex items-center rounded-md cursor-pointer }`}
              // onClick={() => setOpenCalendar(!openCalendar)}
              >
                <IoCalendarOutline
                  sx={{ color: mode === "dark" ? "#A5A5A5" : "" }}
                  size="18px"
                />
              </Box>

              {/* Next Week Button */}
              <IoIosArrowForward
                fontSize="small"
                className="cursor-pointer hover:text-gray-600"
                onClick={handleNextWeek}
                // color="#398aff"
                sx={{ color: mode === "dark" ? "#A5A5A5" : "" }}
              />
            </div>

            <span className="text-sm font-medium">
              {view === "Weekly" ? `${formattedStart} - ${formattedEnd}` : monthYearLabel}
            </span>

          </div>

          <div
            className="flex gap-1 md:gap-3 md:items-center"
            style={{ display: "flex" }}
          >
            <ToggleButtonGroup
              value={view}
              exclusive
              onChange={(e, newView) => newView && setView(newView)}
              sx={{
                height: "32px",
              }}
            >
              <ToggleButton
                value="Weekly"
                sx={{
                  fontSize: { md: "14px", xs: "10px" },
                  height: "32px",
                  width: "80px",
                  backgroundColor:
                    view === "Weekly"
                      ? `${themeMode === "light"
                        ? "#ffffff !important"
                        : "transparent"
                      } `
                      : "transparent",
                  // border:
                  //   view === "Weekly"
                  //     ? "2px solid #0088ff"
                  //     : "2px solid transparent",
                  color: view === "Weekly" ? "black" : "grey",
                }}
              >
                Weekly
              </ToggleButton>
              <ToggleButton
                value="Monthly"
                disableRipple
                sx={{
                  fontSize: { md: "14px", xs: "10px" },
                  height: "32px",
                  width: "80px",
                  backgroundColor:
                    view === "Monthly"
                      ? `${themeMode === "light"
                        ? "#ffffff !important"
                        : "transparent"
                      } `
                      : "transparent",
                  // border:
                  //   view === "Monthly"
                  //     ? "2px solid #0088ff"
                  //     : "2px solid transparent",
                  color: view === "Monthly" ? "black" : "grey",
                }}
              >
                Monthly
              </ToggleButton>
            </ToggleButtonGroup>

            {/* {currentOrg.type === "Owner" && ( */}
            <div>
              <Button
                variant="contained"
                color="primary"
                onClick={() => handleOpen("assign")}
                // onClick={() => setOpen((prev) => !prev)}
                sx={{
                  fontSize: { md: "14px", xs: "10px" },
                  height: "32px",
                  width: "130px",
                  backgroundColor: "#0080FF",
                }}
              >
                Assign Shift
              </Button>
            </div>
            {/* )} */}

            {/* <div
              className={`relative h-fit group p-2 rounded-md ${themeMode === "light" ? "bg-[#fff]" : ""
                }`}
              onClick={() => setIsOpen(!isOpen)}
            >
              <IoIosMore size={17} className="cursor-pointer" />
              {isOpen && (
                <Box
                  sx={{
                    backgroundColor: themeMode === "light" ? "#fff" : "#363636",
                  }}
                  className="absolute w-[180px] z-40 right-2 p-5 flex flex-col gap-4 rounded-lg top-10"
                >
                  <div className="flex gap-2 items-center cursor-pointer">
                    <CiImport size={18} />
                    <p className="text-[14px]">Import</p>
                  </div>
                  <div className="flex gap-2 items-center cursor-pointer">
                    <CiExport size={18} />
                    <p className="text-[14px]">Export</p>
                  </div>
                  <div className="flex gap-2 items-center cursor-pointer">
                    <TfiDownload size={18} />
                    <p className="text-[14px]">Download as PDF</p>
                  </div>
                  <div className="flex gap-2 items-center cursor-pointer">
                    <BsPrinter size={18} />
                    <p className="text-[14px]">Print</p>
                  </div>
                </Box>
              )}
              <span className="absolute left-1/2 -translate-x-1/2 w-[max-content] text-xs bg-gray-800 text-white px-2 py-1 rounded opacity-0 group-hover:opacity-100 transition">
                More
              </span>
            </div> */}
          </div>
        </Box>

        <div className="mx-[30px]">
          {view === "Weekly" ? (
            <WeekTab selectedShift={selectedShift} selectedDate={selectedDate} />
          ) : (
            <MonthTab selectedShift={selectedShift} selectedDate={selectedDate} />
          )}
          <EditShiftModal
            open={open}
            handleClose={() => setOpen(false)}
            mode={mode}
          />
        </div>
      </Box>
    </>
  );
};

export default Shift;